import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import { MotionConfig, motion } from 'framer-motion';
import { Glyph } from './Glyph';
import { findNavEntry } from './navConfig';
import s from './PageTitle.module.css';
/**
 * Page heading with the section's glyph — the same icon as in the sidebar,
 * looked up by the current path; it pops in when the page opens. `children`
 * sit on the right (page actions).
 */
export function PageTitle({ title, sub, children, }) {
    const { pathname } = useLocation();
    const entry = findNavEntry(pathname);
    return (_jsxs("header", { className: s.head, children: [entry && (_jsx(MotionConfig, { reducedMotion: "user", children: _jsx(motion.span, { className: s.glyph, initial: { opacity: 0, scale: 0.6, rotate: -8 }, animate: { opacity: 1, scale: 1, rotate: 0 }, transition: { type: 'spring', stiffness: 380, damping: 22, delay: 0.05 }, children: _jsx(Glyph, { icon: entry.icon, size: "lg" }) }) })), _jsxs("div", { className: s.text, children: [_jsx("h1", { className: s.title, children: title }), sub && _jsx("div", { className: s.sub, children: sub })] }), children && _jsx("div", { className: s.actions, children: children })] }));
}
